import React, { useEffect, useState } from 'react'
import { useFormik } from "formik"
import * as Yup from "yup"
import { Button, Col, Form, FormFeedback, FormGroup, Input, Label, Modal, ModalBody, ModalHeader, Row } from 'reactstrap'
import useApi from 'common/ApiMiddlewere'
import toast from 'react-hot-toast'
import Dropzone from "react-dropzone"
import uploadImage from "../../assets/images/uploadImage.png"
import Compressor from "compressorjs"

const CreateHandWorkModel = ({ modal, toggle, HandWorkListApi, isEdit, editData, designerId, handworkOrderId, categoriesIds }) => {
    const { postApi, putApi, getApi } = useApi()
    const [formSumitLoading, setformSumitLoading] = useState(false)
    const [previewUrl, setPreviewUrl] = useState(editData?.Image1 ?? '')
    const [previewUrl1, setPreviewUrl1] = useState(editData?.Image2 ?? '')
    const [previewUrl2, setPreviewUrl2] = useState(editData?.Image3 ?? '')
    const [base64Image1, setBase64Image1] = useState()
    const [base64Image2, setBase64Image2] = useState('')
    const [base64Image3, setBase64Image3] = useState('')
    const [isUpdateImage1, setIsUpdateImage1] = useState(false)
    const [isUpdateImage2, setIsUpdateImage2] = useState(false)
    const [isUpdateImage3, setIsUpdateImage3] = useState(false)
    const [categoriesData, setCategoriesData] = useState([])
    const [categoryId, setCategoryId] = useState(editData?.CategoryId ?? 0)
    const [categoryError, setCategoryError] = useState(false)
    const [isStitching, setIsStitching] = useState(false)

    useEffect(() => {
        if (!isEdit) {
            setPreviewUrl('')
            setPreviewUrl1('')
            setPreviewUrl2('')
        } else {
            setPreviewUrl(editData?.Image1 ?? '')
            setPreviewUrl1(editData?.Image2 ?? '')
            setPreviewUrl2(editData?.Image3 ?? '')
            setCategoryId(editData?.CategoryId ?? 0)
        }

        getApi('Common/category/lookup').then(({ data, status }) => {
            if (status === 200) {
                var selectedCategories = []
                if (isEdit && categoriesIds) {
                    selectedCategories = data.filter(item =>
                        categoriesIds?.split(",")?.includes(item.Key.toString())
                    );
                } else {
                    selectedCategories = data.filter(item =>
                        editData?.HandWorkUseCategoryIds?.split(",")?.includes(item.Key.toString())
                    );
                }
                setCategoriesData(selectedCategories);
            } else {
                toast.error(data, {
                    style: {
                        fontSize: "15px",
                    },
                })
            }
        });
    }, [editData, isEdit, modal])

    const handleKeyPress = event => {
        const charCode = event.which || event.keyCode;
        if (charCode < 48 || charCode > 57) {
            event.preventDefault();
        }
    };

    //  Validations
    const validation = useFormik({
        enableReinitialize: true,
        initialValues: {
        },
        validationSchema: Yup.object({
        }),
        onSubmit: values => {

            if (categoryId == 0 && !isEdit) {
                setCategoryError(true)
                return true
            }
            setformSumitLoading(true)
            if (values) {
                if (isEdit) {
                    putApi("HandWorkCosting/update", {
                        id: parseInt(editData?.Id),
                        Image1: isUpdateImage1 ? base64Image1?.split(",")[1] : previewUrl,
                        Image2: isUpdateImage2 ? base64Image2?.split(",")[1] : previewUrl1,
                        Image3: isUpdateImage3 ? base64Image3?.split(",")[1] : previewUrl2,
                    }).then(({ data, status }) => {
                        setformSumitLoading(false)
                        if (status == 400) {
                            toast.error(data, {
                                style: {
                                    fontSize: "15px",
                                },
                            })
                        } else {
                            toast.success(`Sucessfully updated`, {
                                style: {
                                    fontSize: "15px",
                                },
                            })
                            setformSumitLoading(false)
                            toggle()
                            if (HandWorkListApi != '') {
                                HandWorkListApi()
                            }
                            validation.handleReset()
                        }
                    })
                } else {
                    postApi("HandWorkCosting/create", {
                        CategoryId: parseInt(categoryId),
                        HandworkOrderId: parseInt(handworkOrderId),
                        Image1: isUpdateImage1 ? base64Image1?.split(",")[1] : previewUrl,
                        Image2: isUpdateImage2 ? base64Image2?.split(",")[1] : previewUrl1,
                        Image3: isUpdateImage3 ? base64Image3?.split(",")[1] : previewUrl2,
                        isStitching: isStitching
                    }).then(({ data, status }) => {
                        setformSumitLoading(false)
                        if (status == 400) {
                            toast.error(data, {
                                style: {
                                    fontSize: "15px",
                                },
                            })
                        } else {
                            toast.success(`Sucessfully created`, {
                                style: {
                                    fontSize: "15px",
                                },
                            })
                            setformSumitLoading(false)
                            toggle()
                            if (HandWorkListApi != '') {
                                HandWorkListApi()
                            }
                            validation.handleReset()
                        }
                    })
                }
            }
        },
    })

    // cancle handler
    const handleCancle = () => {
        toggle()
    }

    const toBase64 = file =>
        new Promise((resolve, reject) => {
            const reader = new FileReader()
            reader.readAsDataURL(file)
            reader.onload = () => resolve(reader.result)
            reader.onerror = error => reject(error)
        })

    const handleDrop1 = acceptedFiles => {
        const selectedFile = acceptedFiles[0]
        new Compressor(selectedFile, {
            quality: 0.4, // 0.6 can also be used, but its not recommended to go below.
            success: async compressedResult => {
                setIsUpdateImage1(true)
                setPreviewUrl(URL.createObjectURL(compressedResult))
                setBase64Image1(await toBase64(compressedResult))
            },
        })
    }

    const handleDrop2 = acceptedFiles => {
        const selectedFile = acceptedFiles[0]
        new Compressor(selectedFile, {
            quality: 0.4, // 0.6 can also be used, but its not recommended to go below.
            success: async compressedResult => {
                setIsUpdateImage2(true)
                setPreviewUrl1(URL.createObjectURL(compressedResult))
                setBase64Image2(await toBase64(compressedResult))
            },
        })
    }
    const handleDrop3 = acceptedFiles => {
        const selectedFile = acceptedFiles[0]
        new Compressor(selectedFile, {
            quality: 0.4, // 0.6 can also be used, but its not recommended to go below.
            success: async compressedResult => {
                setIsUpdateImage3(true)
                setPreviewUrl2(URL.createObjectURL(compressedResult))
                setBase64Image3(await toBase64(compressedResult))
            },
        })
    }

    const handleCategoryChange = (categoryId) => {
        setCategoryError(false)
        setCategoryId(categoryId)
    }

    const [isMobile, setisMobile] = useState(window.innerWidth < 924)
    return (
        <Modal
            isOpen={modal}
            toggle={toggle}
            centered={true}
            size="defualt"
            style={{ width: !isMobile ? "800px" : "" }}
        >
            <div className="modal-content">
                <ModalHeader toggle={toggle} tag="h5">
                    {isEdit ? "Update Hand Work" : "Create Hand Work"}
                </ModalHeader>
                <ModalBody>
                    <Form
                        onSubmit={e => {
                            e.preventDefault()
                            validation.handleSubmit()
                            return false
                        }}
                        onReset={e => {
                            e.preventDefault
                            validation.handleReset()
                            return false
                        }}
                    >
                        {!isEdit &&
                            <Row>
                                <Col md={4}>
                                    <FormGroup className="mb-2">
                                        <Label htmlFor="validationCustom03" className="required">
                                            Category
                                        </Label>
                                        <Input
                                            type="select"
                                            id="validationCustom01"
                                            className="form-control-sm"
                                            onChange={e => { handleCategoryChange(e.target.value) }}
                                            value={categoryId}
                                            bsSize="sm"
                                            name="category"
                                            style={{ width: "150px" }}
                                        >
                                            <option value={0}>
                                                Select
                                            </option>
                                            {categoriesData.map((item, index) => {
                                                return (
                                                    <option key={index} value={item.Key}>
                                                        {item.Value}
                                                    </option>
                                                )
                                            })}
                                        </Input>
                                        {categoryError ? (
                                            <FormFeedback type="invalid">
                                                {"Category is required"}
                                            </FormFeedback>
                                        ) : null}
                                    </FormGroup>
                                </Col>
                                <Col md={3} style={{ marginTop: "25px" }}>
                                    <div className="" >
                                        <FormGroup check>
                                            <Input
                                                type="checkbox"
                                                id='isStitching'
                                                defaultChecked={isStitching}
                                                onChange={(e) => setIsStitching(e.target.checked)}
                                            />
                                            <Label for='isStitching' check>
                                                Is stitching
                                            </Label>
                                        </FormGroup>
                                    </div>
                                </Col>
                            </Row>
                        }
                        <Row>
                            <Label className="mb-0"><b>Upload Images</b></Label>
                            <Col md={4}>
                                <FormGroup>
                                    <Dropzone
                                        onDrop={handleDrop1}
                                        onClick={handleDrop1}
                                        accept="image/*"
                                        multiple={false}
                                        id="profilePic"
                                        name="profilePic"
                                    >
                                        {({ getRootProps, getInputProps }) => (
                                            <>
                                                <div className="d-flex flex-column align-items-center text-center p-2 py-3">
                                                    {previewUrl ? (
                                                        <>
                                                            <div className="position-relative overflow-hidden product-image">
                                                                <input {...getInputProps()} />
                                                                <img
                                                                    style={{
                                                                        cursor: "pointer",
                                                                        border: "1px solid #ced4da",
                                                                        borderRadius: "3px",
                                                                    }}
                                                                    width="175px"
                                                                    height="200px"
                                                                    src={previewUrl}
                                                                    {...getRootProps()}
                                                                />
                                                            </div>
                                                        </>
                                                    ) : (
                                                        <>
                                                            <input {...getInputProps()} />

                                                            <div
                                                                style={{
                                                                    width: "175px",
                                                                    height: "200px",
                                                                    border: "1px solid #ced4da",
                                                                    cursor: "pointer",
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                    justifyContent: "center",
                                                                    borderRadius: "3px",
                                                                }}
                                                            >
                                                                <img
                                                                    className="img-fluid"
                                                                    style={{}}
                                                                    src={uploadImage}
                                                                    {...getRootProps()}
                                                                />
                                                            </div>
                                                        </>
                                                    )}
                                                </div>
                                            </>
                                        )}
                                    </Dropzone>
                                </FormGroup>
                            </Col>
                            <Col md={4}>
                                <FormGroup>
                                    <Dropzone
                                        onDrop={handleDrop2}
                                        onClick={handleDrop2}
                                        accept="image/*"
                                        multiple={false}
                                        id="profilePic"
                                        name="profilePic"
                                    >
                                        {({ getRootProps, getInputProps }) => (
                                            <>
                                                <div className="d-flex flex-column align-items-center text-center p-2 py-3">
                                                    {previewUrl1 ? (
                                                        <>
                                                            <div className="position-relative overflow-hidden product-image">
                                                                <input {...getInputProps()} />
                                                                <img
                                                                    style={{
                                                                        cursor: "pointer",
                                                                        border: "1px solid #ced4da",
                                                                        borderRadius: "3px",
                                                                    }}
                                                                    width="175px"
                                                                    height="200px"
                                                                    src={previewUrl1}
                                                                    {...getRootProps()}
                                                                />
                                                            </div>
                                                        </>
                                                    ) : (
                                                        <>
                                                            <input {...getInputProps()} />

                                                            <div
                                                                style={{
                                                                    width: "175px",
                                                                    height: "200px",
                                                                    border: "1px solid #ced4da",
                                                                    cursor: "pointer",
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                    justifyContent: "center",
                                                                    borderRadius: "3px",
                                                                }}
                                                            >
                                                                <img
                                                                    className="img-fluid"
                                                                    style={{}}
                                                                    src={uploadImage}
                                                                    {...getRootProps()}
                                                                />
                                                            </div>
                                                        </>
                                                    )}
                                                </div>
                                            </>
                                        )}
                                    </Dropzone>
                                </FormGroup>
                            </Col>
                            <Col md={4}>
                                <FormGroup>
                                    <Dropzone
                                        onDrop={handleDrop3}
                                        onClick={handleDrop3}
                                        accept="image/*"
                                        multiple={false}
                                        id="profilePic"
                                        name="profilePic"
                                    >
                                        {({ getRootProps, getInputProps }) => (
                                            <>
                                                <div className="d-flex flex-column align-items-center text-center p-2 py-3">
                                                    {previewUrl2 ? (
                                                        <>
                                                            <div className="position-relative overflow-hidden product-image">
                                                                <input {...getInputProps()} />
                                                                <img
                                                                    style={{
                                                                        cursor: "pointer",
                                                                        border: "1px solid #ced4da",
                                                                        borderRadius: "3px",
                                                                    }}
                                                                    width="175px"
                                                                    height="200px"
                                                                    src={previewUrl2}
                                                                    {...getRootProps()}
                                                                />
                                                            </div>
                                                        </>
                                                    ) : (
                                                        <>
                                                            <input {...getInputProps()} />

                                                            <div
                                                                style={{
                                                                    width: "175px",
                                                                    height: "200px",
                                                                    border: "1px solid #ced4da",
                                                                    cursor: "pointer",
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                    justifyContent: "center",
                                                                    borderRadius: "3px",
                                                                }}
                                                            >
                                                                <img
                                                                    className="img-fluid"
                                                                    style={{}}
                                                                    src={uploadImage}
                                                                    {...getRootProps()}
                                                                />
                                                            </div>
                                                        </>
                                                    )}
                                                </div>
                                            </>
                                        )}
                                    </Dropzone>
                                </FormGroup>
                            </Col>
                        </Row>

                        <div className="text-end">
                            {isEdit ? (
                                <Button
                                    user="secondary"
                                    className="btn btn-primary me-2 btn-sm "
                                    onClick={handleCancle}
                                >
                                    Cancle
                                </Button>
                            ) : (
                                <Button
                                    user="secondary"
                                    className="btn btn-primary me-2 btn-sm "
                                    type="reset"
                                >
                                    Reset
                                </Button>
                            )}
                            {formSumitLoading ? (
                                <button
                                    type="button"
                                    className="btn btn-primary btn-sm"
                                    color="secondary"
                                >
                                    <i className="bx bx-hourglass bx-spin font-size-16 align-middle me-2"></i>
                                    Loading
                                </button>
                            ) : (
                                <Button
                                    user="primary"
                                    className="btn btn-primary btn-sm "
                                    type="submit"
                                    color="primary"
                                >
                                    Submit
                                </Button>
                            )}
                        </div>
                    </Form>
                </ModalBody>
            </div>
        </Modal>
    )
}

export default CreateHandWorkModel